"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _url = require("url");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Label = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Label"));
var _TextField = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/TextField"));
var _AddPillButton = _interopRequireDefault(require("../AddPillButton"));
var _PillLink = _interopRequireDefault(require("../PillLink"));
var refUtils = _interopRequireWildcard(require("../../utils/refs"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable react/destructuring-assignment */
var styles = {
  "container": "EditableLabels__container__pb40B",
  "labels-title": "EditableLabels__labels-title__1hJwa",
  "labelsTitle": "EditableLabels__labels-title__1hJwa",
  "labels-container": "EditableLabels__labels-container__1HAvf",
  "labelsContainer": "EditableLabels__labels-container__1HAvf",
  "textfield": "EditableLabels__textfield__1RhSB",
  "error": "EditableLabels__error__ju8un",
  "error-message": "EditableLabels__error-message__3JHjm",
  "errorMessage": "EditableLabels__error-message__3JHjm"
}; 
require('./EditableLabels.css');
var EditableLabels = /*#__PURE__*/function (_React$Component) {
  function EditableLabels() {
    var _this;
    (0, _classCallCheck2.default)(this, EditableLabels);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, EditableLabels, [].concat(args));
    (0, _defineProperty2.default)(_this, "addTagRef", /*#__PURE__*/_react.default.createRef());
    (0, _defineProperty2.default)(_this, "state", {
      isCreating: false,
      isValid: true,
      value: '',
      errorMessage: ''
    });
    (0, _defineProperty2.default)(_this, "getTagURL", function (tagName) {
      var pathname = _this.props.router.getPath('home');
      var query = {
        search: "tag:\"".concat(tagName, "\""),
        show: 'all'
      };
      return (0, _url.format)({
        pathname: pathname,
        query: query
      });
    });
    (0, _defineProperty2.default)(_this, "handleTextFieldEnter", function (_ref) {
      var value = _ref.value;
      var labelName = value.trim();
      if (labelName) {
        var _this$props$asset = _this.props.asset,
          organizationId = _this$props$asset.organization.id,
          groupId = _this$props$asset.groupId,
          assetId = _this$props$asset.assetId,
          version = _this$props$asset.version,
          labels = _this$props$asset.labels;
        var newLabel = labelName.toLowerCase();
        if (!labels.some(function (label) {
          return label.toLowerCase() === newLabel;
        })) {
          _this.props.onUpdateLabels({
            organizationId: organizationId,
            groupId: groupId,
            assetId: assetId,
            version: version,
            labels: labels.concat([newLabel])
          });
          _this.setState({
            value: '',
            errorMessage: '',
            isValid: true
          });
        } else {
          _this.setState({
            isValid: false,
            errorMessage: 'Duplicate tag name'
          });
        }
      }
    });
    (0, _defineProperty2.default)(_this, "handleTextFieldBlur", function () {
      _this.leaveCreatingState();
    });
    (0, _defineProperty2.default)(_this, "handleTextFieldKeyDown", function (event) {
      if (event.key === 'Escape') {
        _this.leaveCreatingState();
      }
    });
    (0, _defineProperty2.default)(_this, "handleNewLabelClick", function () {
      _this.setState({
        isCreating: true,
        isValid: true
      });
      _this.props.onNewLabelClick();
    });
    (0, _defineProperty2.default)(_this, "handlePillRemove", function (removedLabel) {
      var _this$props$asset2 = _this.props.asset,
        organizationId = _this$props$asset2.organization.id,
        groupId = _this$props$asset2.groupId,
        assetId = _this$props$asset2.assetId,
        version = _this$props$asset2.version,
        labels = _this$props$asset2.labels;
      _this.props.onUpdateLabels({
        organizationId: organizationId,
        groupId: groupId,
        assetId: assetId,
        version: version,
        labels: labels.filter(function (label) {
          return label !== removedLabel;
        })
      });
      _this.leaveCreatingState();
    });
    (0, _defineProperty2.default)(_this, "leaveCreatingState", function () {
      _this.setState({
        isCreating: false,
        value: '',
        errorMessage: ''
      });
      _this.props.onLeaveCreatingState();
    });
    (0, _defineProperty2.default)(_this, "handleTextFieldChange", function (_ref2) {
      var value = _ref2.value;
      return _this.setState({
        value: value
      });
    });
    return _this;
  }
  (0, _inherits2.default)(EditableLabels, _React$Component);
  return (0, _createClass2.default)(EditableLabels, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.isCreating && !this.state.isCreating) {
        refUtils.focus(this.addTagRef);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        isCreating = _this$state.isCreating,
        isValid = _this$state.isValid,
        value = _this$state.value,
        errorMessage = _this$state.errorMessage;
      var asset = this.props.asset;
      return /*#__PURE__*/_react.default.createElement("section", {
        "data-test-id": "asset-labels-list",
        "aria-labelledby": "tags-heading",
        className: styles.container
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: "tags-heading",
        className: "visually-hidden"
      }, "Tags"), /*#__PURE__*/_react.default.createElement("div", {
        className: styles.labelsContainer,
        "aria-live": "polite"
      }, (asset.labels || []).map(function (label, index) {
        return /*#__PURE__*/_react.default.createElement(_PillLink.default
        // eslint-disable-next-line react/no-array-index-key
        , {
          key: "tag-".concat(index),
          to: _this2.getTagURL(label),
          "aria-label": "Go to tag ".concat(label),
          onRemove: function onRemove() {
            return _this2.handlePillRemove(label);
          },
          title: label
        }, label);
      }), isCreating ? /*#__PURE__*/_react.default.createElement(_Label.default, {
        className: "visually-hidden",
        htmlFor: "add-new-label"
      }, "Tag") : null, isCreating ? /*#__PURE__*/_react.default.createElement(_TextField.default, {
        id: "add-new-label",
        testId: "add-new-label",
        name: "label",
        type: "text",
        required: true,
        onEnter: this.handleTextFieldEnter,
        onKeyDown: this.handleTextFieldKeyDown,
        onBlur: this.handleTextFieldBlur,
        placeholder: "Add a tag...",
        className: (0, _classnames.default)(styles.textfield, (0, _defineProperty2.default)({}, styles.error, !isValid)),
        isValid: isValid,
        autoFocus: true,
        onChange: this.handleTextFieldChange,
        value: value,
        maxLength: EditableLabels.maxLabelLength
      }) : null, !isValid && isCreating ? /*#__PURE__*/_react.default.createElement("div", {
        role: "alert",
        "data-test-id": "label-error-message",
        className: (0, _classnames.default)(styles.errorMessage)
      }, errorMessage) : null, !isCreating ? /*#__PURE__*/_react.default.createElement(_AddPillButton.default, {
        ref: this.addTagRef,
        "data-test-id": "add-label",
        className: styles.action,
        onClick: this.handleNewLabelClick
      }, "Add a tag") : null));
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(EditableLabels, "maxLabelLength", 512);
var _default = exports.default = EditableLabels;
//# sourceMappingURL=EditableLabels.js.map